// src/styles/Colors.js
export const COLORS = {
    primary: '#F39C12', // Arancione Finday
    primaryDark: '#E67E22', // Versione più scura
    primaryLight: '#FFD180', // Versione più chiara
    secondary: '#801054', // Colore complementare (bordeaux)
    secondaryLight: '#B71A75', // Versione più chiara 
    text: '#333333', // Testo principale
    textLight: '#666666', // Testo secondario
    background: '#FFFFFF', // Sfondo
    backgroundLight: '#F9F9F9', // Sfondo alternativo
    border: '#EEEEEE', // Bordi
    success: '#2ECC71', // Verde per successo
    error: '#E74C3C', // Rosso per errori
  };
  